import { ReactNode } from 'react';
import { withStyles, CheckboxIndicator } from 'vopay';
import styles from './RoleCheckbox.module.scss';

const cn = withStyles(styles);

type RoleCheckboxProps = {
  name: string;
  checked: boolean;
  label: ReactNode;
  disabled?: boolean;
  labelPosition?: 'left' | 'right';
  onChange: (checked: boolean) => void;
};

export default function RoleCheckbox({
  name,
  checked,
  label,
  disabled,
  labelPosition = 'left',
  onChange,
}: RoleCheckboxProps) {
  const indicator = <CheckboxIndicator checked={checked} />;
  const labelEl = <span>{label}</span>;

  return (
    <label htmlFor={name} className={cn('checkbox', labelPosition === 'right' && 'labelPositionRight')}>
      {labelPosition === 'right' ? labelEl : indicator}

      <input
        id={name}
        name={name}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className={cn('visuallyHidden')}
        disabled={disabled}
      />

      {labelPosition === 'right' ? indicator : labelEl}
    </label>
  );
}
